import React, { useEffect, useState } from "react";
import { useField, useFormikContext } from "formik";
import _, { at } from "lodash";
import { FileUploader } from "react-drag-drop-files";
import "./CsplDragDropField.css";
import { useTranslation } from "react-i18next";
import styles from "./CsplDragDrop.module.css";
import ReactTooltip from "react-tooltip";
import CsplPreviewModal from "../CsplPreviewModal/CsplPreviewModal";
import { MaxFileSizeToUpload } from "../../../Utils/GlobalValues";
import { FileTypeEnum } from "../../../Enumeration/FileTypeEnum";
import UseFormikHelper from "../../../Utils/UseFormikHelper";
import InnerContent from "./InnerContent";
import { DragDropEnum } from "../../../Enumeration/DragDropEnum";
import FileResource from "../../Resources/CommonResources/FileResource";

function CsplDragDrop(props) {

/******* Refactored code */

{/*
** reauired pros *
1.FiledName for file name
2. field name for base64
3.filePath


***** optional ***
1.onFileUpload
2.required
3.disabled
4.MaxFileSize
5.allowedFileTypes
6.clearDependancyData
7.resettingBasedOnDependency
*/}
const { t } = useTranslation("common");
const [fileBase64String, setFileBase64String] = useState("");
const [fileName, setFileName] = useState("");
const [filePath,setFilePath] = useState("");
const [required, setRequired] = useState(false);
const [disabled, setDisabled] = useState(false);
const [maxFileSize, setMaxFileSize] = useState();
const [instructionText, setInstructionText] = useState();
const [allowedFileTypes, setAllowedFileTypes] = useState();
const [innerText, setInnerText] = useState(t("dragDrop.dragAndDropOrBrowseYouFiles"));
const [dragDropClass, setDragDropClass] = useState(DragDropEnum.csplDragNotUploaded);
const [showpopup, setShowpopup] = useState(false);
const[isloading,setIsloading] = useState(false);
const[isUploadStatus,setIsUploadStatus] = useState(DragDropEnum.csplDragNotUploaded);
let allowedFiles = [
  FileTypeEnum.JPG,
  FileTypeEnum.JPEG,
  FileTypeEnum.PNG,
  FileTypeEnum.PDF,
];
const [file, setFile] = useState(null);
const reader = new FileReader();
const{setValue}= UseFormikHelper();
const{setFieldTouched}= useFormikContext();
const[getUploadedContent, getUploadedContentEnc]=FileResource();
/* Tooltip Ellipsis Case */
const [tooltip, showTooltip] = useState(true);
 
//create fromik states
const { errorText, ...rest } = props;
// create formik props for base64String
const base64Props={name:props.base64FieldName};
const [base64Field, base64Meta] = useField(base64Props);
const fileNameProps={name:props.fileNameFieldName};
const [fileNameField, fileNameMeta] = useField(fileNameProps);
const filePathProps={name:props.path};
const [filePathField, filePathMeta] = useField(filePathProps);
const [error] = at(fileNameMeta, 'error');
const[errorDescription,setErrorDescription] =useState("");

function _renderHelperText() {
  const [touched, error] = at(fileNameMeta, 'touched', 'error');
  if (touched && (error|| errorDescription)) {
    return (errorDescription||error);
  }
}

useEffect(() => {
  if (base64Field.value !== fileBase64String) {
    if(base64Field.value !== undefined && base64Field.value !== null){
      setFileBase64String(base64Field.value);
    }else{
      setFileBase64String("");
    }
    setErrorDescription("");
  }  
}, [base64Field.value]);

//style changes based on error and upload status
useEffect(() => {
  if ( ((errorDescription || error ) && fileNameMeta.touched )|| isUploadStatus === DragDropEnum.csplDragError) {
    setDragDropClass(DragDropEnum.csplDragError);
  }
  else if(isUploadStatus === DragDropEnum.csplDragNotUploaded) {
    setDragDropClass(DragDropEnum.csplDragNotUploaded);
  }
  else if(isUploadStatus === DragDropEnum.csplDragSuccess){
    setDragDropClass(DragDropEnum.csplDragSuccess);
  }
}, [error,errorDescription,fileNameMeta.touched]);

//defaulting file name and style if exist
useEffect(() => {
  if (fileNameField.value !== fileName) {
    if(fileNameField.value){
      setFileName(fileNameField.value);
      setIsUploadStatus(DragDropEnum.csplDragSuccess);
      setDragDropClass(DragDropEnum.csplDragSuccess);
      setInnerText(t("dragDrop.uploadedSuccessFully"));
    }else if(!errorDescription){
      setFileName("");
      setIsUploadStatus(DragDropEnum.csplDragNotUploaded);
      setDragDropClass(DragDropEnum.csplDragNotUploaded);
      setInnerText(t("dragDrop.dragAndDropOrBrowseYouFiles"));
    }else{
      setFileName("");
    }
  }  
}, [fileNameField.value]);

useEffect(() => {
  if (filePathField.value !== filePath) {
    if(filePathField.value !== undefined && filePathField.value !== null){
      setFilePath(filePathField.value);
    }else{
      setFilePath("");
    }
    }  
}, [filePathField.value]);

useEffect(() => {
  if(props.required !== null){
    setRequired(props.required);
  }
}, [props.required])

useEffect(() => {
  if(props.disabled !== null){
    setDisabled(props.disabled);
  }
}, [props.disabled])

useEffect(() => {
  if(props.maxFileSize !== null){
    setMaxFileSize(props.maxFileSize);
    constructAndAssignInstructionText(allowedFileTypes,props.maxFileSize);
  }
}, [props.maxFileSize])

useEffect(() => {
  if(props.allowedFileTypes !== null){
    setAllowedFileTypes(props.allowedFileTypes);
    constructAndAssignInstructionText(props.allowedFileTypes,maxFileSize);
  }
}, [props.allowedFileTypes])



/**
 * Construct instruction text based on allowed file types and file size
 * @param {array} allowedFileTypes 
 * @param {int} maxFileSize 
 */
const constructAndAssignInstructionText=(allowedFileTypes,maxFileSize)=>{
  let allowedFileString='';
  let instructionMsg='';

  if(allowedFileTypes){
    allowedFileString = allowedFileTypes.join(",");
  }

  if(allowedFileString !==''){
    instructionMsg = 'Supports '+allowedFileString; 
  }

  if(maxFileSize){
    if(instructionMsg !== ''){
      instructionMsg =instructionMsg +" | File size : max "+maxFileSize+" MB";
    }else{
      instructionMsg ="File size : max "+maxFileSize+" MB";
    }
  }

  setInstructionText(instructionMsg);
}

/** inuitilize allowed file type and max file size */
useEffect(() => {
  setAllowedFileTypes(allowedFiles);
  setMaxFileSize(MaxFileSizeToUpload);
  constructAndAssignInstructionText(allowedFiles, MaxFileSizeToUpload);
}, []);

  //File on-change
  function handleChange(file) {   
    setErrorDescription("");
    removeFileData();
    setDisabled(true);
    setIsUploadStatus(DragDropEnum.csplDragNotUploaded);   
    setDragData(
      file,
      t("dragDrop.upload_in_progress"),
      DragDropEnum.csplDragNotUploaded
    );
    setIsloading(true);
    getBase64(file).then((data) => {
       
      if (props.onFileUpload && typeof (props.onFileUpload) === "function") {
        props.onFileUpload(file,data,file.name).then((res)=>{ 
          setIsloading(false);  
          setDragDropClass(DragDropEnum.csplDragSuccess); 
          setIsUploadStatus(DragDropEnum.csplDragSuccess);    
          setInnerText(t("dragDrop.uploadedSuccessFully"));
          assignValuesToField(res.content, res.fileName);
          setDisabled(false);          
        },(error)=>{
          //do nothing
          setIsloading(false);
          setInnerText(error);
          setIsUploadStatus(DragDropEnum.csplDragError);
          removeFileData(); 
          setDragDropClass(DragDropEnum.csplDragError);
          setFieldTouched(props.base64FieldName,true);
          setFieldTouched(props.fileNameFieldName,true);
          setDisabled(false);                      
        })
      }
      else{
        setIsloading(false);
        setDragDropClass(DragDropEnum.csplDragSuccess);
        setIsUploadStatus(DragDropEnum.csplDragSuccess);
        setInnerText(t("dragDrop.uploadedSuccessFully"));        
        assignValuesToField(data, file.name);
        setDisabled(false);     
      }     
    });
  }

  //removeFileData
  function removeFileData() {
    setFileName("");
    setFileBase64String("");  
    assignValuesToField("","");
  }

  //settingFieldValues
  function assignValuesToField(data, fileName) {
      setValue(props.base64FieldName, data);
      setValue(props.fileNameFieldName, fileName);
      setValue(props.path,"")
  }

  

  //generating base 64 string from file
  function getBase64(file) {
    return new Promise((resolve, reject) => {
      reader.readAsDataURL(file);
      reader.onload = () => {
        let base64String = reader.result
          .replace("data:", "")
          .replace(/^.+,/, "");
        resolve(base64String);
      };

      reader.onerror = (error) => reject(error);
    });
  }
 
  //clear upload
  function removeFile(e) {
    e.preventDefault();
    setIsUploadStatus(DragDropEnum.csplDragNotUploaded);
    setDragData(
      null,
      t("dragDrop.dragAndDropOrBrowseYouFiles"),
      DragDropEnum.csplDragNotUploaded
    );
    assignValuesToField("","");    
    if (props.clearDependancyData && typeof (props.clearDependancyData) === "function") {
         props.clearDependancyData();
    }   
  }

  //file Type Error Handler
  function typeErrorHandler(typeError) {
    invalidUploadHandler(t("dragDrop.invalidFileFormat"));
  }

  //size Error Handler
  function sizeErrorHandler(sizeError) {
    invalidUploadHandler(t("dragDrop.fileSizeExceedsMaximumLimit"));
  }

  // error Handler
  function invalidUploadHandler(errorText){
    setDragData(null, errorText, DragDropEnum.csplDragError);    
    removeFileData();  
    setIsUploadStatus(DragDropEnum.csplDragError);
    assignValuesToField("",""); 
    if (props.clearDependancyData && typeof (props.clearDependancyData) === "function") {
      props.clearDependancyData();
    }
    setFieldTouched(props.base64FieldName,true)

  }

  

  /**
   * set Drag Data
   * @param  file
   * @param InnerText
   * @param  DragDropClass
   */
  function setDragData(file, InnerText, DragDropClass) {
    setFile(file);
    setInnerText(InnerText);
    setDragDropClass(DragDropClass);
  }
  /* pop open close */
  function handlePreviewClose() {
    setShowpopup(false);
  } 

  useEffect(()=>{
    setErrorDescription(props.errorDescription);
  },[props.errorDescription])

  //resetting based on dependency
  useEffect(()=>{
    if(props.resettingBasedOnDependency){
      removeFileData(); 
      setIsUploadStatus(DragDropEnum.csplDragNotUploaded);
      setDragDropClass(DragDropEnum.csplDragNotUploaded);
      setInnerText(t("dragDrop.dragAndDropOrBrowseYouFiles"));
    }
  },[props.resettingBasedOnDependency])


  const showPreview = (e) => {
    e.preventDefault();
    if (fileBase64String) {
      setShowpopup(true);
    } else if (filePath) {
      //get file/image base64 string from path
      getUploadedContentEnc(filePath).then(
        (res) => {
          if (res !== null && res !== "") {
            setFileBase64String(res);
            setShowpopup(true);
          }
        },
        (error) => {}
      );
    }
  };

  /* Ellipsis Tooltip */
  function TooltipToggle(e){
    if(e.target.scrollWidth > e.target.clientWidth){
      showTooltip(true); // show
    } else {
      showTooltip(false); // hide
    }
  } 

 

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between p-1 mx-auto">
        <div className="w-100 me-lg-2 me-1">
          <div className="d-flex justify-content-between mx-auto">
            <span className={styles.cspl_drag_title}>
              {t(props.label)}
              {required === true ? " *" : ""}
            </span>
            <span className={styles.file_instruction}>
              {instructionText}
            </span>
          </div>
          {/* Info Text for File Instruction */}
          {props.infotext &&  <div className={styles.file_infoinstruction}>
                    {t(props.infotext)}  </div> }
          <section className="mx-auto mt-2 main_drop">
            <FileUploader
              className="fileupload"
              handleChange={handleChange}
              name="file"
              types={allowedFileTypes}
              maxSize={maxFileSize}
              onTypeError={typeErrorHandler}
              onSizeError={sizeErrorHandler}
              children={innerText}
              classes={dragDropClass}
              multiple={false}
              fileOrFiles={file}
              disabled={disabled}
            >
              <InnerContent showLoader={isloading} innertext={innerText}/>
              </FileUploader>
          </section>
          <div className="d-flex justify-content-between flex-column">
          <div className="w-100">
          {fileName && fileName !==""&& (
            <section>
              <span className={styles.drag_info_txt}> To view the uploaded image click  </span>
               {/* Ellipsis Tooltip */}
             {tooltip && <ReactTooltip effect="solid" place="bottom" className="customeTheme" />}
             <span
                className={styles.drag_fileName_pointer}
                onClick={showPreview}
                data-tip={fileName}
                onMouseEnter={TooltipToggle}
                onMouseLeave={() => {
                  showTooltip(false);
                }}
              >
                {fileName}  {/* Filename */} 
              </span> 
              {!disabled &&
                <>
                <button
                className="btn shadow-none red-color px-1 py-auto my-auto"
                data-tip
                data-for="RemoveUploadFile"
                onClick={removeFile}
                type="button"
              >
             <span className="round_close"></span> {/* Remove Icon */}
              </button>
              <ReactTooltip id="RemoveUploadFile" place="bottom" effect="solid" className="customeTheme" >
                {t("dragDrop.remove_the_uploaded_file")}
              </ReactTooltip>
                </>                           
          }       
            </section>
          ) }
          </div>
          <div className="w-100">
          {<span className={styles.cspldragdrop_error}>{_renderHelperText()}</span>}
          </div>
          </div>
        </div>
      </div>

      {/* pop up modal */}
      {showpopup &&
      <CsplPreviewModal        
        showPreview={showpopup}
        onClose={handlePreviewClose}
        fileName={fileName}        
        base64String={fileBase64String}
      ></CsplPreviewModal>
    }
    </React.Fragment>
  );
}

export default CsplDragDrop;
